import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    loginData: {
        email: '',
        password: '',
    },
    validation: null,
    error: null,
    user: null,
    loading: false,
    passwordResetRequired: false,
}


export default handleActions({
    [type.CHANGE_LOGIN_DATA]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            loginData: {
                ...state.loginData,
                [name]: value,
            },
        }
    },
    [type.LOGIN_REQUEST]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        }
    },
    [type.LOGIN_SUCCESS]: (state, action) => {
        const { user } = action.payload
        return {
            ...state,
            loading: false,
            user,
        }
    },
    [type.LOGIN_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            loading: false,
            error,
        }
    },
    [type.LOGIN_PASSWORD_RESET_REQUIRED]: (state, action) => {
        return {
            ...state,
            loading: false,
            passwordResetRequired: true,
        }
    },
    [type.CHANGE_PASSWORD_REQUEST]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        }
    },
    [type.CHANGE_PASSWORD_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            loading: false,
            error,
        }
    },
    [type.LOGOUT_SUCCESS]: (state, action) => {
        return initialState
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/security/state/auth/reducer.js